module.exports = __webpack_public_path__ + "static/media/franchiseLogo.2879402c.png";